export const initStateConceptsDiscount = (
    Object.assign({
      data                       : [],
      concepts_discount_selected : [],
      concept_discount_spanish   : '',
      concept_discount_english   : '',
      amount                     : 0,
      actionForm                 : false,
      conceptDiscountId          : ''
    })
 );